// extracted by mini-css-extract-plugin
export default {"card":"ArticleCard_card__Y7oHk","img":"ArticleCard_img__pME16","titleAfter":"ArticleCard_titleAfter__e+1AH"};